<template>
  <v-card min-width="21vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 pt-7">
      <v-form v-model="valid">
        <v-autocomplete :label="$t('broker')" :items="brokers" item-text="name" item-value="id" :rules="brokerRule"
                        :hint="$t('brokerHint')" v-model="brokerChoosed" outlined/>
        <v-text-field v-if="brokerChoosed !== 0"
                      :label="$t((directIntegratedAccount)? 'metaTraderCredentials.identifier' : 'identifier')"
                      v-model="accountId" :rules="(directIntegratedAccount)? loginRules : []" outlined/>
        <v-select v-if="directIntegratedAccount" :label="$t('metaTraderCredentials.server')" :items="servers" item-text="name"
                  item-value="host"
                  v-model="server" :rules="serverRules" outlined/>
        <v-select v-if="brokerChoosed !== 0 && !directIntegratedAccount" :label="$t('type')" :items="accountTypes"
                  :rules="accountTypeRule" v-model="typeChoosed"
                  outlined/>
        <v-select v-if="brokerChoosed !== 0 && !directIntegratedAccount" :label="$t('currency')" :items="currencies"
                  :rules="currencyRule" v-model="currencyChoosed" outlined/>
        <v-chip v-if="directIntegratedAccount" class="my-3" color="calmGreen">
          {{ $t('metaTraderCredentials.alert') }}
        </v-chip>
        <p v-if="directIntegratedAccount" style="font-size: 15px; color: #6b6b6b" class="text-center mb-7"
           v-html="$t('metaTraderCredentials.complianceUrl')"/>
        <v-btn :disabled="!valid" @click="addBrokerAccount" class="mt-2">{{ $t('btnAdd') }}</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import RepositoryBrokerAccount from '../../../repositories/brokerAccount';
import RepositoryMetaTrader from '../../../repositories/metaTraderCredentials';
import axios from 'axios';

export default {
  name: "AddBrokerAccount",
  data() {
    return {
      valid: false,
      accountTypes: ['Live', 'Demo'],
      brokersWithMT4IntegrationIds: [316], // Should be obtained from db

      servers: [
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo 2', host: 'demo.ava-mt-2.com' },
        //{ name: 'Equiti-Demo', host: 'demo.equiti-demo.com' },
        //{ name: 'Equiti-Live', host: 'demo.equiti-live.com' },
        //{ name: 'EquitiGroup-Demo', host: 'demo.equitigroup-demo.com' },
        //{ name: 'EquitiGroup-Live', host: 'demo.equitigroup-live.com' },
        //{ name: 'EquitiGroup-Live 2', host: 'demo.equitigroup-live-2.com' },
        {name: 'ZenfinexGlobal-Demo', host: '52.56.239.235', type: 'Demo'}, // Are managerAPI server's IPs secrets?
        {name: 'ZenfinexGlobal-Live', host: '18.168.113.125', type: 'Live'},
      ],

      brokers: [],
      accountId: '',
      typeChoosed: 'Demo',
      brokerChoosed: 0,
      currencyChoosed: 'USD',
      currencies: [
        'USD',
        'AUD',
        'EUR',
        'GBP',
        'JPY',
        'BRL',
        'MXN',
        'COP',
        'CLP',
      ],
      server: '',

      // Rules
      brokerRule: [
        b => !!b || this.$t('validations.broker'),
      ],
      accountTypeRule: [
        a => !!a || this.$t('validations.type'),
      ],
      currencyRule: [
        c => !!c || this.$t('validations.currency'),
      ],
      loginRules: [
          l => !!l || this.$t('validations.login'),
      ],
      serverRules: [
        s => !!s || this.$t('validations.server'),
      ],
    };
  },
  computed: {
    directIntegratedAccount() {
      return this.brokersWithMT4IntegrationIds.findIndex((broker) => broker === this.brokerChoosed) !== -1;
    }
  },
  watch: {
    server() {
      this.typeChoosed = this.servers.find((s) => s.host === this.server).type;
    }
  },
  mounted() {
    this.loadBrokers();
  },
  methods: {
    async loadBrokers() {
      let finished = false;
      for (let i = 0; !finished; i++)
        await axios.get(`${this.$store.state.backend}/brokers?page=${i}`).then(
            (response) => {
              if (response.data.length > 0)
                response.data.forEach((item) => {
                  this.brokers.push(item);
                });
              else
                finished = true;
            });
      this.brokers.sort((one, two) => (one.name > two.name) ? 1 : (one.name < two.name) ? -1 : 0);
    },
    ...mapMutations(['setBrokerAccounts']),
    addBrokerAccount() {
      if (this.valid) {
        let brokerAccount = {
          broker: { id: this.brokerChoosed },
          user: { id: this.$store.state.user.id },
          type: this.typeChoosed.toUpperCase(),
          identifier: this.accountId,
          currency: this.currencyChoosed,
        };

        RepositoryBrokerAccount.createBrokerAccount(brokerAccount).then((response) => {
          if(response.status < 400) {

            // Creating their MetaTrader credentials
            if(this.directIntegratedAccount) {
              let metaTraderCredentials = {
                brokerAccount: { id: response.data.id },
                server: this.server,
                login: this.accountId,
                version: 'MT4',
              };

              RepositoryMetaTrader.createCredentials(metaTraderCredentials);
            }

            alert(this.$t('createdAlert'));
            RepositoryBrokerAccount.allBrokerAccountsOfUser().then((response) => {
              this.setBrokerAccounts(response.data);
            }).catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error.message);
            });
          }
        });
        this.$emit('closeWindow');
      }
    },
    closeWindow() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Add Broker Account",
    "broker": "Broker",
    "brokerHint": "Broker Name",
    "identifier": "Account ID",
    "type": "Account Type",
    "currency": "Account Currency",
    "linkMetaTraderCredentials": "Your account were be auto-updated",
    "btnAdd": "Add Account",
    "createdAlert": "Your broker account was created!",
    "metaTraderCredentials": {
      "server": "Broker Server",
      "identifier": "Account Login",
      "alert": "Your trades will be automatically synced",
      "complianceCheck": "I agree the monitoring of my trading activity and history.",
      "complianceUrl": "See our Terms and Conditions <a href='https://swiset.com/terms-and-conditions' target='_blank'>clicking here</a>."
    },
    "validations": {
      "broker": "Broker is required",
      "type": "Type is required",
      "currency": "Currency is required",
      "login": "Login is required",
      "server": "Server is required"
    }
  },
  "es": {
    "title": "Agregar Cuenta de Broker",
    "broker": "Broker",
    "brokerHint": "Nombre del Broker",
    "identifier": "ID de Cuenta",
    "type": "Tipo de Cuenta",
    "currency": "Moneda de Cuenta",
    "btnAdd": "Agregar Cuenta",
    "createdAlert": "¡Tu cuenta de broker fue creada!",
    "metaTraderCredentials": {
      "server": "Servidor del Broker",
      "identifier": "Login de Cuenta",
      "alert": "Tus trades serán automáticamente conectados",
      "complianceCheck": "Estoy de acuerdo con el monitoreo de mi actividad e historial.",
      "complianceUrl": "Ver los términos y condiciones <a href='https://swiset.com/es/terminos-y-condiciones' target='_blank'>dando click aquí</a>."
    },
    "validations": {
      "broker": "Broker es obligatorio",
      "type": "Tipo es obligatorio",
      "currency": "Moneda es obligatorio",
      "login": "Login es obligatorio",
      "server": "Servidor es obligatorio"
    }
  }
}
</i18n>

<style scoped>

</style>
